import { Component, Input } from '@angular/core';

@Component({
	selector: 'sparkle-twinkle',
	standalone: true,
	templateUrl: './sparkle.html',
	styleUrl: './sparkle.scss'
})
export class SparkleComponent {
	private variant: '1' | '2' = '1';

	@Input({ alias: 'sparkleVariant' })
	set sparkleVariant(value: string | number | null | undefined) {
		if (value === null || value === undefined) {
			this.variant = '1';
			return;
		}

		const normalized = String(value).trim();
		this.variant = normalized === '2' ? '2' : '1';
	}

	get sparkleSrc(): string {
		return this.variant === '2'
			? 'assets/images/game/sparkle2.png'
			: 'assets/images/game/sparkle1.png';
	}
}

